<template>
    <integration-layout>

        <div v-if="loading_context">
            <spinner class="mx-auto h-5 w-5 text-gray-500"></spinner>
        </div>

        <div v-else-if="!integration" class="text-sm px-3 text-gray-600 font-helvetica">
            <div>
               
                <p v-if="!context.user.isAdmin" class="mt-3">You must use an <strong>Administrator</strong> account to complete Birdie installation.</p>
                <p v-else-if="!signingin">Connect to your Birdie workspace to complete installation</p>
                <p v-else>Refresh your browser once Helpscout is successfully connected to Birdie.</p>
                
                <div v-if="!context.user.isAdmin" class="text-white bg-birdie-blue px-3 py-2 rounded-md inline-flex flex-shrink items-center gap-x-2 mt-3 opacity-40">
                    <span class="font-bold">Connect</span>
                    <ArrowTopRightOnSquareIcon class="w-4 h-4" />
                </div>
                <a v-else-if="!signingin" class="text-white bg-birdie-blue px-3 py-2 rounded-md inline-flex flex-shrink items-center gap-x-2 mt-3 cursor-pointer hover:opacity-80" :href="connect_link" target="_blank" @click="connectLinkClicked">
                    <span class="font-bold">Connect</span>
                    <ArrowTopRightOnSquareIcon class="w-4 h-4" />
                </a>
            </div>
            
            <a class="no-underline hover:underline mt-5 inline-flex gap-x-1 items-center"
                href="https://docs.birdie.so/birdie-docs/helpdesk/helpscout/installation"
                title="Birdie docs"
                target="_blank">
                <QuestionMarkCircleIcon class="w-4 h-4 text-gray-500" /> Get help 
            </a>

        </div>


        <div v-else-if="!is_valid" class="text-sm px-3 text-gray-600 font-helvetica">
            <div class="font-bold">Authentication Error</div>
            <p class="mt-2">Please ensure that your <a :href="customapp_link" target="_blank" class="text-birdie-blue hover:underline">Helpscout Custom App</a> Secret Key matches the one provided on your <a :href="settings_link" target="_blank" class="text-birdie-blue hover:underline">Birdie installation instructions</a> page.</p>
            <p class="mt-4">For help see our <a href="https://docs.birdie.so/birdie-docs/helpdesk/helpscout/installation" target="_blank" class="text-birdie-blue hover:underline">Birdie docs</a></p>
        </div>


        <integration-helpscout v-else
            :agents_can="agents_can"
            :appId="appId"
            :companyId="companyId"
            :has_cobrowsing="has_cobrowsing"
            :has_screenrecording="has_screenrecording"
            :context="context"
            :team_slugname="team_slugname"
            :team_slug="team_slug"
            :missing_essential_data="missing_essential_data"
            @setClipboard="setClipboard"
            @setNotification="setNotification"
            :secure_code="secure_code"
            :utf8_to_b64="utf8_to_b64"
            :getContext="getContext"
            :is_chat="is_chat">
        </integration-helpscout>


    </integration-layout>
</template>

<script>

    import IntegrationLayout from "@/Layouts/IntegrationLayout"
    import IntegrationHelpscout from '@/Components/Integrations/Helpscout/IntegrationHelpscout'
    import HelpScout from '@helpscout/javascript-sdk'
    import Spinner from '@/Components/UI/Spinner'
    import { ArrowTopRightOnSquareIcon, QuestionMarkCircleIcon } from "@heroicons/vue/20/solid"



    export default {
        name: "HelpscoutApp",

        props: [
            'agents_can',
            'appId',
            'companyId',
            'has_cobrowsing',
            'has_screenrecording',
            'integration',
            'is_valid',
            'settings_link',
            'customapp_link',
            'recsec',
            'team_slugname',
            'team_slug'
            
        ],


        components: {
            IntegrationLayout, IntegrationHelpscout,
            Spinner, ArrowTopRightOnSquareIcon, QuestionMarkCircleIcon
        },
        data() {
            return {
                loading_context: true,
                context: {},
                signingin: false,
                missing_essential_data: false,
                is_chat: false
            }
        },
        created() {
            HelpScout.watchApplicationContext(context => {
                this.context = context
                this.refreshedContext()
            });
        },
        beforeUnmount() {

        },
        mounted() {
            this.getContext()
        },
        computed: {
            
            connect_link() {
                if (this.context) {
                    var url = this.$page.props.app_url + '/helpscout/install/'
                    const hc = {
                        user_name: this.context.user.firstName+' '+this.context.user.lastName,
                        user_email: this.context.user.email,
                        user_id: this.context.user.id,
                        mailbox_id: this.context.mailbox.id,
                        mailbox_email: this.context.mailbox.email,
                        mailbox_name: this.context.mailbox.name,
                        company_id: this.context.company.id
                    }
                    const unsecured = this.utf8_to_b64(JSON.stringify(hc))
                    const secured = this.secure_code(unsecured)
                    return url + secured
                }
                return '#'
            }
        },
        methods: {
            refreshedContext: function() {
                // console.log("HelpScout context", this.context)
                this.missing_essential_data = !this.context.customer
                this.is_chat = this.context.customer && !this.context.conversation
            },
            connectLinkClicked: function() {
                this.signingin = true
            },
            utf8_to_b64: function(str) {
                return window.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, 
                    function toSolidBytes(match, p1) {
                        return String.fromCharCode('0x' + p1);
                    }
                ));
            },
            b64_to_utf8: function(str) {
                return decodeURIComponent(window.atob(str).split('').map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));
            },
            secure_code: function(str) {
                const key = this.recsec
                // Get a random position between 1 and B.length - 1
                const pos = Math.floor(Math.random() * (str.length - 1)) + 1
                // Insert A into B at the random position
                const secured = str.slice(0, pos) + key + str.slice(pos)
                return secured
            },
            getContext: function() {
                this.loading_context = true
                HelpScout.getApplicationContext().then((context) => {
                    this.loading_context = false
                    this.context = context
                    //console.log('HelpScout Context:', this.context);
                    this.refreshedContext()
                }).catch((error) => {
                    console.error('Error fetching Help Scout Context:', error);
                });
            },
            setClipboard: function(str, success="Text copied") {
                HelpScout.setClipboardText(str, success)
            },
            setNotification: function(str, type="MESSAGE") {
                // types are: 'CONFIRM', 'ERROR', 'MESSAGE', 'SUCCESS', 'WARNING'
                HelpScout.showNotification(type, str)
            }
        }
    }
</script>

<style scoped>


.fade-enter-active, .fade-leave-active {
    transition: opacity .5s ease;
}
.fade-enter-from, .fade-leave-to {
    opacity: 0;
}


.slide-fade-enter-active {
    transition: all .3s ease-out;
}
.slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
}


</style>
